import zod from "zod";

export const addQuestionInputSchema = zod.object({
    title: zod
        .string()
        .trim()
        .min(1, { message: "質問内容を入力してください。" }),
    answererId: zod.string().min(1),
});

export type AddQuestionInput = zod.infer<typeof addQuestionInputSchema>;
